const existingReservation = document.getElementById('balloon-flight-booking-app').dataset.existingReservation === '1' || sessionStorage.getItem('reservation') !== null;
const reservation = document.getElementById('balloon-flight-booking-app').dataset.reservation
    ? JSON.parse(document.getElementById('balloon-flight-booking-app').dataset.reservation)
    : JSON.parse(sessionStorage.getItem('reservation'));

module.exports = { existingReservation, reservation };
